import { useLocation, useOutlet } from "react-router";
import { AnimatePresence, m } from "framer-motion";
import { cloneElement } from "react";

import type { Variants } from "framer-motion";

const pageVariants: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.25, ease: "easeOut" as const } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.15, ease: "easeIn" as const } },
};

export function AnimatedOutlet() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <AnimatePresence mode="wait">
      <m.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        {outlet && cloneElement(outlet, { key: location.pathname })}
      </m.div>
    </AnimatePresence>
  );
}
